import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { notification } from "antd";
import { magicLogin } from "../services/authAPI";
import { jwtDecode } from "jwt-decode";

const MagicLinkHandler = () => {
  const {
    login,
    logout,
    isAuthenticated,
    setSelectedProject,
    currentUser,
    setMagicLoginActive,
  } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    const redirectWithParams = (rfi_id, submittalId) => {
      if (submittalId) {
        navigate(`/submittals?submittal_id=${submittalId}`);
      } else if (rfi_id) {
        navigate(`/rfis?rfi_id=${rfi_id}`);
      } else {
        navigate("/");
      }
    };

    const processToken = (decodedToken) => {
      const { rfi_id, project_id, submittal_id: submittalId } = decodedToken;

      if (project_id) {
        const matchedProject = currentUser?.projects?.find(
          (project) => project.project_id === project_id
        );
        if (matchedProject) {
          setSelectedProject(matchedProject);
        } else {
          navigate("/login");
          return;
        }
      }

      redirectWithParams(rfi_id, submittalId);
    };

    const handleMagicLogin = async () => {
      try {
        const data = await magicLogin(token);
        const decodedToken = jwtDecode(token);
        if (data.token && decodedToken?.type === "magic_login") {
          if (data.project_id) {
            const hasProject = data.user.projects?.some(
              (p) => p.project_id === data.project_id
            );
            if (!hasProject) {
              navigate("/login");
              return;
            }
          }

          await logout();
          localStorage.setItem("login_type", "magic_login");
          setMagicLoginActive(true);
          await login(data.user, data.token, data.project_id);

          window.history.replaceState(null, "", window.location.pathname);
          redirectWithParams(data.rfi_id, data.submittal_id);
        } else {
          notification.error({
            message: "Invalid Link",
            description: "The magic link is invalid or expired.",
          });
          navigate("/login");
        }
      } catch (error) {
        const detail = error?.response?.data?.detail;

        let description = "An error occurred during login. Please try again.";
        let message = "Login Failed";

        if (detail === "Magic link expired") {
          message = "Link Expired";
          description =
            "Your magic login link has expired. Please request a new one.";
        } else if (
          detail === "Invalid token" ||
          detail === "Invalid token type" ||
          detail === "Invalid token payload"
        ) {
          message = "Invalid Link";
          description =
            "The magic login link is invalid or has been tampered with.";
        }

        notification.error({ message, description });
        navigate("/login");
      }
    };

    if (token) {
      if (isAuthenticated) {
        const decodedToken = jwtDecode(token);
        processToken(decodedToken);
        localStorage.removeItem("login_type");
      } else {
        handleMagicLogin();
      }
    } else if (isAuthenticated) {
      navigate("/");
    }
  }, [
    location.search,
    login,
    logout,
    navigate,
    isAuthenticated,
    currentUser?.projects,
  ]);
  

  return null;
};

export default MagicLinkHandler;
